import { useState } from 'react'
import { Dropdown, DropdownItem, AptiveIcon } from '@aptive-env/storybook'
import ServiceCard from 'components/ServiceCard'
import { IFleetRoute } from 'interface/map'

const sortTypes = ['Service Pro', 'Homes to Service', 'Miles to Drive', 'Drive Time', 'Service Time', 'Unassigned Routes', 'In Trouble Routes']
const orderTypes = ['Ascending', 'Descending']

const Routes = ({ items, isStarted }: { items: IFleetRoute[], isStarted: boolean }) => {
  const [typeDropdownOpen, setTypeDropdownOpen] = useState(false)
  const [orderDropdownOpen, setOrderDropdownOpen] = useState(false)
  const [selectedType, setSelectedType] = useState(0)
  const [selectedOrder, setSelectedOrder] = useState(0)

  const toggleDropdown = (option: string) => {
    switch (option) {
    case 'type':
      setTypeDropdownOpen(!typeDropdownOpen)
      break
    case 'order':
      setOrderDropdownOpen(!orderDropdownOpen)
      break
    }
  }

  return (
    <div className="h-[calc(100%-72px)] flex flex-col gap-4">
      <div className="flex items-center gap-2">
        <label className="text-sm leading-4 text-gray-900">Sort by</label>
        <div className="flex grow justify-between">
          <div className="relative z-10">
            <div className="flex items-center cursor-pointer gap-2" onClick={() => toggleDropdown('type')}>
              <span className="text-sm leading-4 text-gray-600">
                {sortTypes[selectedType]}
              </span>
              <AptiveIcon className="w-[20px] h-[20px] stroke-gray-600 fill-none" icon="chevronDown" />
            </div>
            <Dropdown className="!min-w-[170px]" isOpen={typeDropdownOpen} onClose={() => setTypeDropdownOpen(false)}>
              {sortTypes.map((type: string, index: number) => (
                <DropdownItem selected={selectedType === index} onClick={() => setSelectedType(index)} key={type} >
                  {type}
                </DropdownItem>
              ))}
            </Dropdown>
          </div>
          <div className="relative z-10">
            <div className="flex items-center cursor-pointer gap-2" onClick={() => toggleDropdown('order')}>
              <span className="text-sm leading-4 text-gray-600">
                {orderTypes[selectedOrder]}
              </span>
              <AptiveIcon className="w-[20px] h-[20px] stroke-gray-600 fill-none" icon="chevronDown" />
            </div>
            <Dropdown className="right-0 !min-w-[170px]" isOpen={orderDropdownOpen} onClose={() => setOrderDropdownOpen(false)}>
              {orderTypes.map((type: string, index: number) => (
                <DropdownItem selected={selectedOrder === index} onClick={() => setSelectedOrder(index)} key={type} >
                  {type}
                </DropdownItem>
              ))}
            </Dropdown>
          </div>
        </div>
      </div>
      <div className="overflow-auto">
        <div className="flex flex-col gap-4">
          {
            items.map((item: IFleetRoute, index: number) => (
              <ServiceCard
                avatar={item.avatar}
                name={item.service_pro_name}
                statistics={item.statistics}
                key={item.service_pro_id}
                completionPercentage={item.actual_stats?.completion_percentage}
                isStarted={isStarted}
                isAtRisk={item.actual_stats?.at_risk}
                index={index}
              />
            ))
          }
        </div>
      </div>
    </div>
  )   
}

export default Routes
